import {FetchService} from "../../node_modules/cronus-theme/default/global/ts/fetch.service";
import QRCode from "qrcode";

export function initCollectionShare() {
    document.querySelectorAll('.js-shareWeekly').forEach(function (el) {
        el.addEventListener('click', handleShareClick);
    });
}

async function handleShareClick(e) {
    var btn = e.currentTarget;
    var collectionId = btn.dataset.collectionId;
    var shareType = parseInt(btn.dataset.shareType || '0', 10);
    if (!collectionId || collectionId === '0') return;

    var container = document.getElementById('shareQrContainer');
    var infoEl = document.getElementById('shareLinkInfo');
    if (!container || !infoEl) return;

    // Loading-State
    container.innerHTML = '<i class="icon icon-loading"></i>';
    infoEl.innerHTML = '';

    try {
        var response = await FetchService.post('/em/collectionShare/createLink', {
            collectionId: parseInt(collectionId),
            currentUrl: window.location.origin + window.location.pathname + window.location.search,
            type: shareType
        });

        if (response.success) {
            // QR-Code als DataURL generieren
            var qrDataUrl = await QRCode.toDataURL(response.shareLink, { width: 200, margin: 1 });
            container.innerHTML = '<img src="' + qrDataUrl + '" alt="QR-Code" style="max-width:200px;">';

            // Link-Info anzeigen
            var validDate = new Date(response.validUntil);
            var formattedDate = validDate.toLocaleDateString('de-DE', {
                day: '2-digit', month: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit'
            });
            infoEl.innerHTML =
                '<p style="word-break:break-all;font-size:0.85em;margin-top:0.5rem;">' +
                    response.shareLink +
                '</p>' +
                '<p style="font-size:0.8em;color:#666;">G\u00FCltig bis: ' + formattedDate + '</p>';
        } else {
            container.innerHTML = '<p>Fehler beim Erstellen des Links.</p>';
        }
    } catch (err) {
        container.innerHTML = '<p>Fehler beim Erstellen des Links.</p>';
    }
}
